import {
  CalendarCheck,
  Camera,
  Car,
  Clock,
  Coffee,
  Drop,
  Gauge,
  Handshake,
  Leaf,
  Lightning,
  MapPin,
  Medal,
  PaintBrush,
  ShieldCheck,
  Snowflake,
  Sparkle,
  Star,
  Sun,
  ThumbsUp,
  Wrench,
  type Icon as PhosphorIcon,
} from '@phosphor-icons/react';

/** Icon names allowed in business.json info cards (see shared/business.ts). */
const INFO_ICONS: Record<string, PhosphorIcon> = {
  sparkle: Sparkle,
  'shield-check': ShieldCheck,
  clock: Clock,
  car: Car,
  drop: Drop,
  wrench: Wrench,
  star: Star,
  medal: Medal,
  'calendar-check': CalendarCheck,
  'map-pin': MapPin,
  coffee: Coffee,
  camera: Camera,
  lightning: Lightning,
  leaf: Leaf,
  'thumbs-up': ThumbsUp,
  handshake: Handshake,
  gauge: Gauge,
  'paint-brush': PaintBrush,
  sun: Sun,
  snowflake: Snowflake,
};

export function infoIcon(name: string): PhosphorIcon {
  return INFO_ICONS[name] ?? Sparkle;
}
